import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Modal,
  Button,
  SuccessNotification,
} from "components/common";
import { Wrapper } from "./ManageModal.styled";
import { callDeleteApiWithAuth } from "utils/api";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function ManageModal(props) {
 
  const [isUpdating, setIsUpdating] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    
  }, []);


  const onDowngradeDone = () => {
    SuccessNotification("Successfully Downgraded");
    props.setShouldLoad(true);
  }

  const handleDowngrade = () => {
    callDeleteApiWithAuth(
      `my_account/subscription/products/downgrade_akadt/${props.data.id}`,
      onDowngradeDone,
    );
  }

  const handleUpgradeAkashxAnnual = (aka_dt_annual_upgrade) => {
    dispatch({
      type: 'checkout.SET_ORDER_DETAILS',
      payload: [
        {
          product: props.akaAnualProduct,
          quantity: 1,
          pay_cycle: '1',
          contained_products: [],
        }
      ]
    })
    dispatch({
      type: 'checkout.SET_AKA_DT_ANNUAL_UPGRADE',
      payload: aka_dt_annual_upgrade
    })
    history.push("/checkout");
  }

  return (
    <Modal width={480} onCancel={() => props.setIsManage(false)}>
      <Wrapper>
        <div className="modal-new-title">Manage Subscription</div>
        <Row gutter={[20, 10]}>
          <Col span={24}>
            <div className="input-container">
              <Button className="my-2" onClick={() => handleUpgradeAkashxAnnual('2')}>Upgrade to Akashx Annual</Button>
              <Button className="my-2" onClick={() => handleUpgradeAkashxAnnual('1')}>Upgrade to Akashx Annual and Keep DreamTrips Priority</Button>
              <Button className="my-2" onClick={handleDowngrade}>Downgrade to Akashx Monthly</Button>
            </div>
          </Col>
        </Row>
      </Wrapper>
    </Modal>
  );
}
